/* ==========================================================================
   U&S Clothing — Audit fixes
   Upload as: assets/audit-fixes.js
   Loaded from layout/theme.liquid alongside audit-fixes.css
   ========================================================================== */
(function () {
  'use strict';

  /* Run once per page. */
  if (window.__afLoaded) return;
  window.__afLoaded = true;


  /* ------------------------------------------------------------------
     PART 1 — Overlay state + iOS scroll lock
     Audit: Mobile #2, #3, #5(a), #6

     The theme signals "an overlay is open" through several different body
     classes. We normalise them into ONE class (ui-overlay-open) that the
     CSS file uses to hide the WhatsApp + Judge.me widgets, and we do a
     real iOS-safe scroll lock while they're on.
     ------------------------------------------------------------------ */

  var LOCK_CLASSES = [
    'overflow-hidden',
    'overflow-hidden-all',
    'overflow-hidden-tablet',
    'overflow-hidden-mobile'
  ];

  var savedScrollY = 0;
  var isLocked = false;

  function anyOverlayOpen() {
    var b = document.body;
    for (var i = 0; i < LOCK_CLASSES.length; i++) {
      if (b.classList.contains(LOCK_CLASSES[i])) return true;
    }
    if (b.classList.contains('open-submenu-mobile')) return true;
    if (/(^|\s)open-drawer-/.test(b.className)) return true;
    if (document.querySelector('.section-header.menu-open')) return true;
    if (document.querySelector('.popup-modal[open], .drawer.active, .drawer.open-content')) return true;
    return false;
  }

  function applyScrollLock(shouldLock) {
    if (shouldLock === isLocked) return;
    var b = document.body;

    if (shouldLock) {
      savedScrollY = window.scrollY || window.pageYOffset || 0;
      b.style.top = -savedScrollY + 'px';
      isLocked = true;
    } else {
      b.style.top = '';
      isLocked = false;
      window.scrollTo(0, savedScrollY);
    }
  }

  function sync() {
    var open = anyOverlayOpen();
    var has = document.body.classList.contains('ui-overlay-open');

    if (open && !has) document.body.classList.add('ui-overlay-open');
    else if (!open && has) document.body.classList.remove('ui-overlay-open');

    applyScrollLock(open);
    if (open) suppressStrayWidgets();
  }

  /* Belt-and-braces: any position:fixed element parked directly on <body>
     with a huge z-index that we don't own is almost certainly an app widget.
     Tag it so the CSS can hide it, without us having to guess its class. */
  var THEME_OWNED = [
    '.drawer', '.popup-modal', '.floating-element', '.back-button-menu',
    'cart-drawer', 'quick-add-drawer', 'quick-view-modal',
    'toast-message-manager', '[id^="shopify-section"]', '.shopify-section',
    '#MainContent', '.ui-overlay-suppressed'
  ].join(',');

  function suppressStrayWidgets() {
    var kids = document.body.children;
    for (var i = 0; i < kids.length; i++) {
      var el = kids[i];
      if (el.nodeType !== 1) continue;
      if (el.classList.contains('ui-overlay-suppressed')) continue;
      if (el.matches && el.matches(THEME_OWNED)) continue;
      if (el.tagName === 'SCRIPT' || el.tagName === 'STYLE' || el.tagName === 'LINK') continue;

      var cs;
      try { cs = window.getComputedStyle(el); } catch (e) { continue; }
      if (cs.position !== 'fixed') continue;

      var z = parseInt(cs.zIndex, 10);
      if (!(z > 1000)) continue;

      el.classList.add('ui-overlay-suppressed');
    }
  }

  function initOverlayWatcher() {
    sync();
    new MutationObserver(sync).observe(document.body, {
      attributes: true,
      attributeFilter: ['class']
    });
    /* This used to observe document.documentElement with subtree:true, which
       woke on every class change anywhere on the page. Judge.me, WhatsApp,
       Clarity and the countdown app all mutate classes constantly, so the
       callback was running far more than the handful of times it needs to.
       Only the header and the overlay containers actually matter. */
    var watched = document.querySelectorAll(
      '.section-header, .header__inline-menu, .facets-wrapper, ' +
      'cart-drawer, quick-add-drawer, quick-view-modal, menu-drawer'
    );
    Array.prototype.forEach.call(watched, function (node) {
      new MutationObserver(sync).observe(node, {
        subtree: true,
        attributes: true,
        attributeFilter: ['class', 'open']
      });
    });
  }

  /* ------------------------------------------------------------------
     PART 2 — Personalisation fields inside Quick Add / Quick View
     Audit: Mobile #5(b), Desktop #1

     Why they're missing: personalisation is a BLOCK on the main-product
     section, configured per product template (299 of 332 templates use it).
     sections/quick-add-drawer.liquid has no blocks at all, and
     sections/quick-view.liquid has no `when 'personalize_input'` case —
     so neither can ever render them.

     Fix: after the popup opens, fetch the product page, lift the
     personalisation fields out of it, and graft them onto the popup's
     add-to-cart form. Products using the heavier popup personaliser
     (personalize_product / bundle_personalization) or the image-upload
     block can't be safely inlined, so those go to the full product page.
     ------------------------------------------------------------------ */

  /* Cannot be inlined into a popup — must use the full product page.
     .pib-wrapper is the image-upload block: its upload/resize logic lives
     in an inline <script> we strip when cloning, so a cloned copy would
     let the shopper pick a file that never actually uploads. */
  var COMPLEX = '.product__personalize, .personalized-bundle-wrapper, .pib-wrapper, script[id^="CustomiseConfig-"]';
  var SIMPLE = '.product__personalize-input';

  /* NOTE: we fetch the FULL product page, not ?section_id=main-product.
     Personalisation is rendered by an APP BLOCK, and Shopify's Section
     Rendering API strips app blocks out — so the section response never
     contains the fields. The full page does. */
  function fetchProductPage(productUrl) {
    var clean = productUrl.split('?')[0];
    return fetch(clean)
      .then(function (r) { return r.text(); })
      .then(function (t) { return new DOMParser().parseFromString(t, 'text/html'); });
  }

  /* The popup contains TWO forms that both match form[id^="product-form-"]:
     the ShopPay installment form comes first in the DOM, and the real
     add-to-cart form second. Binding fields to the installment form makes
     them look fine but silently drop the value. Always match on data-type. */
  function findAddToCartForm(container) {
    return container.querySelector('form[data-type="add-to-cart-form"]')
        || container.querySelector('product-form form')
        || null;
  }

  function graftFields(container, anchorEl, doc, wrapClass) {
    if (!container || !anchorEl) return;
    if (container.querySelector('.' + wrapClass)) return;

    var fields = doc.querySelectorAll(SIMPLE);
    if (!fields.length) return;

    var formEl = findAddToCartForm(container);
    /* getAttribute('id') — NOT formEl.id. A <form> exposes its named children
       as properties, and these forms contain <input name="id">, so formEl.id
       returns that input element instead of the id string. */
    var formId = formEl ? formEl.getAttribute('id') : null;
    if (!formId) return;

    var wrap = document.createElement('div');
    wrap.className = wrapClass;

    for (var i = 0; i < fields.length; i++) {
      wrap.appendChild(fields[i].cloneNode(true));
    }

    wrap.querySelectorAll('script').forEach(function (s) { s.remove(); });

    wrap.querySelectorAll('input, select, textarea').forEach(function (el) {
      el.setAttribute('form', formId);
      var oid = el.getAttribute('id');
      if (oid) {
        var lbl = wrap.querySelector('label[for="' + oid + '"]');
        if (lbl) lbl.setAttribute('for', oid + '-qa');
        el.setAttribute('id', oid + '-qa');
      }
    });

    anchorEl.parentNode.insertBefore(wrap, anchorEl);
  }

  function enhancePopup(container, productUrl, wrapClass, anchorSelector) {
    if (!container || container.dataset.personalizationDone) return;
    container.dataset.personalizationDone = '1';

    fetchProductPage(productUrl).then(function (doc) {
      if (doc.querySelector(COMPLEX)) {
        window.location.href = productUrl;
        return;
      }
      var anchor = container.querySelector(anchorSelector);
      graftFields(container, anchor, doc, wrapClass);
    }).catch(function (err) {
      console.warn('[audit-fixes] personalisation graft failed', err);
    });
  }

  function waitFor(getEl, cb, timeout) {
    var started = Date.now();
    var t = setInterval(function () {
      var el = getEl();
      if (el) { clearInterval(t); cb(el); return; }
      if (Date.now() - started > (timeout || 12000)) clearInterval(t);
    }, 200);
  }

  /* Shared by the theme's own openers AND by Part 3's homepage cards. */
  function bridgeQuickAddDrawer(productUrl) {
    waitFor(function () {
      var d = document.querySelector('quick-add-drawer');
      return d && d.querySelector('.product__sale-box__actions') ? d : null;
    }, function (drawer) {
      drawer.removeAttribute('data-personalization-done');
      enhancePopup(drawer, productUrl, 'quick-add__personalize', '.product__sale-box__actions');
    });
  }

  function initPersonalizationBridge() {
    document.addEventListener('click', function (e) {
      var target = e.target;
      if (!target || !target.closest) return;

      /* quick-add drawer (mobile AND the desktop "Add to cart" button) */
      var addOpener = target.closest('quick-add-drawer-opener');
      if (addOpener) {
        var addBtn = addOpener.querySelector('button');
        var addUrl = addBtn && addBtn.dataset.productUrl;
        if (!addUrl) return;
        bridgeQuickAddDrawer(addUrl);
        return;
      }

      /* quick-view modal (desktop eye icon) */
      var viewOpener = target.closest('quick-view-modal-opener');
      if (viewOpener) {
        var viewBtn = viewOpener.querySelector('button');
        var viewUrl = viewBtn && viewBtn.dataset.productUrl;
        if (!viewUrl) return;
        waitFor(function () {
          var m = document.querySelector('quick-view-modal [id^="QuickViewInfo-"]');
          return m && m.querySelector('form[data-type="add-to-cart-form"]') ? m : null;
        }, function (modal) {
          modal.removeAttribute('data-personalization-done');
          enhancePopup(modal, viewUrl, 'quick-view__personalize', 'product-form');
        });
      }
    }, true);
  }

  /* ------------------------------------------------------------------
     PART 3 — Homepage featured-product cards
     These custom sections POST {id, quantity} straight to /cart/add.js:
     no variant choice, no properties. So a shopper gets whatever variant
     happened to be first, with no personalisation.

     Fix: route them through the same quick-add drawer the collection
     pages already use.
     ------------------------------------------------------------------ */

  function fctProductUrl(el) {
    var card = el.closest('.fct-card');
    var link = card && card.querySelector('a[href*="/products/"]');
    return link ? link.getAttribute('href').split('?')[0] : null;
  }

  /* Call the theme's own quick-add logic directly.
     Synthesising a <quick-add-drawer-opener> does NOT work: its constructor
     runs querySelector('button') at upgrade time and its click handler
     touches .loading-overlay__spinner, so a scripted element either fails to
     bind or throws — in both cases silently, with nothing happening on click. */
    function openQuickAdd(productUrl) {
    var url = productUrl + (productUrl.indexOf('?') > -1 ? '&' : '?') + 'section_id=quick-add-drawer';

    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (text) {
        var newDrawer = getDomHtmlFromText(text, 'quick-add-drawer');
        if (!newDrawer) throw new Error('no quick-add-drawer in response');

        var existing = document.querySelector('quick-add-drawer');

        if (window.hasQuickAddDrawer && existing) {
          existing.setInnerHTML(newDrawer);
          existing.open();
        } else {
          document.body.appendChild(newDrawer);
          var drawer = document.querySelector('quick-add-drawer');
          HTMLUpdateUtility.reinjectsScripts(drawer);
          drawer.runAfterUpdateHtml();
          window.hasQuickAddDrawer = true;
          setTimeout(function () { drawer.open(); }, 300);
        }

        bridgeQuickAddDrawer(productUrl);
      })
      .catch(function (err) {
        console.warn('[audit-fixes] quick-add failed, falling back to product page', err);
        window.location.href = productUrl;
      });
  }

  function fctGate(e, el) {
    var url = fctProductUrl(el);
    if (!url) return;

    e.preventDefault();
    e.stopPropagation();

    /* image-upload and bundle products can't work inside the drawer —
       send those to the full product page (same rule as Part 2) */
    fetchProductPage(url).then(function (doc) {
      if (doc.querySelector(COMPLEX)) {
        window.location.href = url;
      } else {
        openQuickAdd(url);
      }
    }).catch(function () {
      window.location.href = url;
    });
  }

  function initHomepageGate() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('.fct-atc-icon');
      if (btn) fctGate(e, btn);
    }, true);

    document.addEventListener('submit', function (e) {
      var form = e.target.closest && e.target.closest('.fct-mini-form');
      if (form) fctGate(e, form);
    }, true);
  }

    /* ------------------------------------------------------------------
     PART 4 — Mega menu closes itself while the pointer is still on it

     details-disclosure.js schedules close() on a 300ms timer when the
     pointer leaves, but open() never cancels that timer. Re-entering
     within 300ms sets [open] again while the old timer is still pending,
     so the menu shuts 300ms later with the pointer sitting right on it.
     ------------------------------------------------------------------ */

  function initMegaMenuHoverFix() {
    document.querySelectorAll('.header__inline-menu header-menu, .header__inline-menu details-disclosure')
      .forEach(function (host) {
        var details = host.querySelector('details');
        if (!details) return;

        details.addEventListener('mouseenter', function () {
          if (host.closingTimeout) {
            clearTimeout(host.closingTimeout);
            host.closingTimeout = null;
          }
          details.classList.remove('closing');
        }, true);
      });
  }

    /* ------------------------------------------------------------------
     PART 5 — Header height measured too early

     sticky-header.js measures the header inside connectedCallback and
     writes the result into --sticky-header-height-*, which .section-header
     then uses as min-height. At that moment the webfont and the logo have
     usually not loaded, so it measures a taller header than the final one
     and the difference stays behind as a gap.

     Re-measuring after fonts and images settle fixes it. This is the same
     resize path the theme already uses, so nothing new is introduced.
     ------------------------------------------------------------------ */

  function remeasureHeader() {
    var sticky = document.querySelector('sticky-header');
    if (sticky && typeof sticky.onWindowResize === 'function') {
      sticky.preventResize = false;
      sticky.onWindowResize();
    }
  }

  function initHeaderRemeasure() {
    /* after the webfont swaps in */
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () { setTimeout(remeasureHeader, 60); });
    }

    /* after everything including the logo has loaded */
    window.addEventListener('load', function () { setTimeout(remeasureHeader, 120); });

    /* the logo specifically — it is the tallest thing in the header */
    var logo = document.querySelector('.header__heading-link img, .header__heading img');
    if (logo && !logo.complete) {
      logo.addEventListener('load', function () { setTimeout(remeasureHeader, 60); });
    }

    /* a late safety net for app widgets that inject into the header */
    setTimeout(remeasureHeader, 1500);
  }

  /* ------------------------------------------------------------------ */

  function boot() {
    initOverlayWatcher();
    initPersonalizationBridge();
    initHomepageGate();
    initMegaMenuHoverFix();  
    initHeaderRemeasure();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();